import { Typography } from "antd";
import type React from "react";
import { useMemo } from "react";

type Props = Omit<
  React.ComponentProps<typeof Typography.Paragraph>,
  "ellipsis" | "style"
> & {
  suffixLength?: number;
  text: string;
};

/** Use when the suffix is the meaningful disambiguator (ARNs, paths, ids with
 *  a uuid tail). For ordinary truncation use `Typography.Text` with `ellipsis`. */
export const MiddleTruncatedText: React.FC<Props> = ({
  suffixLength = 12,
  text,
  className,
  ...props
}) => {
  const suffix = text.slice(-suffixLength);
  const body = text.slice(0, Math.max(0, text.length - suffixLength));
  const ellipsis = useMemo(() => ({ suffix, tooltip: text }), [suffix, text]);

  return (
    <Typography.Paragraph
      {...props}
      ellipsis={ellipsis}
      className={className ? `mb-0 ${className}` : "mb-0"}
    >
      {body}
    </Typography.Paragraph>
  );
};
